import { useTheme } from 'styled-components';

import CustomIcon from '@components/utils/CustomIcon';
import { ProfileReservation } from '@assets/icons';
import { TourListDatesViewModel } from '@api/v3';
import { formatISOToDate } from '@utils/dateUtil';
import Tooltip from '@components/ui/Tooltip/next';

import {
  ItemWrapper,
  IconWrapper,
  ItemText,
  ListingItemsWrapper,
  ListingItem,
  TooltipContainer,
} from './styled';

interface Props {
  dates?: TourListDatesViewModel[];
}
const AlternativeDates = ({ dates }: Props) => {
  const { palette } = useTheme();

  return (
    <TooltipContainer>
      <Tooltip
        borderRadius='8px'
        overlayInnerStyle={{
          maxHeight: '108px',
          overflow: 'auto',
          borderRadius: '8px',
          border: 'none',
          minWidth: '156px',
          backgroundColor: palette.white,
          padding: 0,
        }}
        trigger='hover'
        getPopupContainer={(trigger) => trigger}
        placement='top'
        arrowColor={palette.white}
        title={
          <ListingItemsWrapper>
            {dates?.map((item, index) => {
              return (
                <ListingItem key={index}>
                  {`${formatISOToDate(item?.departureDate)} - ${formatISOToDate(
                    item?.arrivalDate
                  )}`}
                </ListingItem>
              );
            })}
          </ListingItemsWrapper>
        }
      >
        <ItemWrapper>
          <IconWrapper>
            <CustomIcon
              icon={ProfileReservation}
              width={16}
              height={16}
              paletteColor='NL800'
            />
          </IconWrapper>
          <ItemText>{`Diğer Tur Tarihleri (${dates?.length})`}</ItemText>
        </ItemWrapper>
      </Tooltip>
    </TooltipContainer>
  );
};

export default AlternativeDates;
